export class Restaurant {
    IDTipoComercio : number;
    IdComercio : number;
    IdPais : number;
    TipoVAT : number;
    NumeroVAT : string;
    NombreComercio : string; 
    MarcaComercial  : string;
    Logo : string;
    AtiendePublico : number;
    GiroComercial : string;
    Lema : string;
    EstadoEnPlataforma : number; 
    MensajeEnCatalogo : string;
    AvisoEnCatalogos : string;
    Venta : number;
    Direcion : string;
    Detalles : string;
    Correo : string;
    TelefonoFijo : number; 
    TelefonoMovil : number; 
    PaginaWeb : string;

    constructor(IDTipoComercio : number, IdComercio : number, IdPais : number, TipoVAT : number, NumeroVAT : string, 
        NombreComercio : string, MarcaComercial  : string, Logo : string, AtiendePublico : number, GiroComercial : string, 
        Lema : string, EstadoEnPlataforma : number, MensajeEnCatalogo : string, AvisoEnCatalogos : string, Venta : number, 
        Direcion : string, Detalles : string, Correo : string, TelefonoFijo : number, TelefonoMovil : number, PaginaWeb : string){
        this.IDTipoComercio = IDTipoComercio;
        this.IdComercio = IdComercio;
        this.IdPais = IdPais;
        this.TipoVAT = TipoVAT;
        this.NumeroVAT = NumeroVAT;
        this.MarcaComercial = MarcaComercial;
        this.Logo = Logo;
        this.GiroComercial = GiroComercial;
        this.Lema = Lema;
        this.EstadoEnPlataforma = EstadoEnPlataforma;
        this.AtiendePublico = AtiendePublico;
        this.Direcion = Direcion;
        this.Detalles = Detalles;
        this.MensajeEnCatalogo = MensajeEnCatalogo;
        this.AvisoEnCatalogos = AvisoEnCatalogos;
        this.Venta = Venta;
        this.TelefonoFijo = TelefonoFijo;
        this.TelefonoMovil = TelefonoMovil;
        this.PaginaWeb = PaginaWeb;
        this.NombreComercio = NombreComercio;
        this.Correo = Correo;
    }
}

export interface AvisoImagenRestaurante {
    Id: number;
    UrlImagen: string;
    Orden: number;
}

export interface AvisoRestaurante {
    AvisoEnCatalogos: string | null;
    ContentLanguage: string;
    TranslationFallback: boolean;
    ImagenesAviso: AvisoImagenRestaurante[];
}
